{
  "allow": "Property '{property}' has been stripped off",
  "appVersionOutdatedMessage": "Your app version is outdated. Please update to the latest version.",
  "appVersionOutdatedTitle": "NORA needs to be updated",
  "arrayContains": "Property '{property}' must contain all values from {values}",
  "arrayMaxSize": "Property '{property}' must contain no more than {max} values",
  "arrayMinSize": "Property '{property}' must contain at least {min} values",
  "arrayNotContains": "Property '{property}' must not contain any values from {values}",
  "arrayNotEmpty": "Property '{property}' must not be an empty array",
  "arrayUnique": "All values in property '{property}' must be unique",
  "attachments.invalidFileType": "Not allowed to upload filetype:",
  "attachments": {
    "attachment": "Files",
    "attachmentDeleted": "This file has been deleted",
    "attachmentFilterNames": {
      "allFiles": "All Files",
      "images": "Images",
      "videos": "Videos",
      "documents": "Documents"
    },
    "enterFileName": "The file name cannot be empty. Please enter a file name.",
    "editFileName": "Edit file name",
    "editFileNameLabel": "File name",
    "file": "sent a file",
    "files": "sent {0} files",
    "filesAttached": "Files attached",
    "image": "sent an image",
    "invalidFileType": "Not allowed to upload filetype:",
    "librarySelection": "Choose from library",
    "noAttachments": "No files in this conversation",
    "searchPlaceholder": "Enter filename...",
    "selectFiles": "Select Files",
    "sort": {
      "createdAt:asc": "Created ascending",
      "createdAt:desc": "Created descending",
      "fileName:asc": "Name ascending",
      "fileName:desc": "Name descending",
      "size:asc": "Size ascending",
      "size:desc": "Size descending",
      "updatedAt:asc": "Updated ascending",
      "updatedAt:desc": "Updated descending"
    },
    "uploadedBy": "Uploaded {0} by {1}",
    "uploadingSelection": "Upload files",
    "video": "sent a video"
  },
  "geofence.alarm": "Geofence alarm triggered",
  "geofence.alarm:title": "Geofence alarm",
  "geofence.alarm:body": "Geofence rule triggered",
  "file": {
    "validation": {
      "folderNameRequired": "Folder name must not be empty",
      "folderNameInvalid": "Folder name contains unsupported characters or is too long"
    }
  },
  "nexus.operation.invite.sent:title": "You have been invited to an operation",
  "nexus.operation.invite.sent:body": "You have been invited to {operationName} by {senderDisplayName}",
  "chat.conversation.create": "You have been added to a conversation {conversation}",
  "chat.conversation.create:body": "You were added by {senderDisplayName}",
  "chat.conversation.create:title": "{conversationTitle}",
  "chat.conversation.message.create": "You have received a message in {conversation} from {sender}",
  "chat.conversation.message.create:body": "{senderDisplayName} sent a message",
  "chat.conversation.message.create:title": "{conversationTitle}",
  "chat.conversation.message.reaction.create": "You have a new reaction",
  "chat.conversation.message.reaction.create:body": "{senderDisplayName} reacted to your message",
  "chat.conversation.message.reaction.create:title": "{conversationTitle}",
  "chat.conversation.update:body": "You were added by {senderDisplayName}",
  "chat.conversation.update:title": "{conversationTitle}",
  "chat.legacy.conversation.message.create": "You have a message: {text}",
  "commands": {
    "availableCommands": "Available commands",
    "closeMenu": "Close this menu",
    "noResults": "No results",
    "plugins": {
      "conversations": {
        "createConversationDescription": "Start a new conversation",
        "createConversationKeywords": "create conversation new chat",
        "createConversationTitle": "Create conversation",
        "openConversation": "Open conversation: {0}",
        "toggleConversationsDescription": "Open or close the conversation window",
        "toggleConversationsKeywords": "open close conversation chat",
        "toggleConversationsTitle": "Toggle conversations"
      },
      "files": {
        "toggleFilesDescription": "Toggle files",
        "toggleFilesKeywords": "open close file files",
        "toggleFilesTitle": "Open or close the files window"
      },
      "groups": {
        "toggleGroupsDescription": "Toggle groups",
        "toggleGroupsKeywords": "open close group groups",
        "toggleGroupsTitle": "Open or close the groups window"
      },
      "location": {
        "navigateToLocationDescription": "Navigate to a location based on lon/lat coordinates",
        "navigateToLocationKeywords": "goto locate location",
        "navigateToLocationTitle": "Navigate to location"
      },
      "notifications": {
        "toggleNotificationsDescription": "Open or close the notifications window",
        "toggleNotificationsKeywords": "open close notification notifications",
        "toggleNotificationsTitle": "Toggle notifications"
      },
      "operations": {
        "createOperationDescription": "Start a new operation",
        "createOperationKeywords": "Create operation",
        "createOperationTitle": "Create operation",
        "toggleOperationsDescription": "Open or close the operations/ops window",
        "toggleOperationsKeywords": "operation ops open operation close operation operations",
        "toggleOperationsTitle": "Toggle operations"
      },
      "settings": {
        "toggleDarkMode": "Toggle dark mode",
        "setDarkMode": "Set dark mode",
        "setLightMode": "Set light mode",
        "setSystemMode": "Set dark/light to follow system",
        "toggleSettingsDescription": "Open or close the settings window",
        "toggleSettingsKeywords": "open close setting settings",
        "toggleSettingsTitle": "Toggle settings"
      },
      "windows": {
        "toggleCloseAllWindowsDescription": "Close all windows",
        "toggleCloseAllWindowsKeywords": "close window windows modal modals",
        "toggleCloseAllWindowsTitle": "Close all windows"
      }
    },
    "geofence": {
      "ruleType": {
        "CROSS_LINE": "Cross line",
        "NO_LOCATION": "No location",
        "IDLE_LOCATION": "Idle location",
        "ENTER": "Enter",
        "EXIT": "Exit",
        "INSIDE_AT": "Inside at",
        "OUTSIDE_AT": "Outside at",
        "CONVERGE": "Converge",
        "DIVERGE": "Diverge",
        "DEVIATE": "Deviate"
      },
      "errors": {
        "failedGeofenceCreate": "Could not create geofence rule",
        "invalidRuleCombination": "Invalid geofence rule combination",
        "failedToLoadGeofenceRules": "Could not load geofence rules"
      }
    },
    "equals": "Property '{property}' must be equal to '{comparison}'",
    "errors": {
      "addReactionError": "Couldn't add reaction",
      "createConversationError": "Couldn't create conversation",
      "deleteConversationError": "Couldn't delete conversation",
      "deleteMessageError": "Couldn't delete message",
      "deleteReactionError": "Couldn't delete reaction",
      "forwardMessageError": "Couldn't forward message",
      "getAttachmentError": "Error fetching attachments.",
      "loadingMessagesError": "Couldn't load messages",
      "muteConversationError": "Unable to mute conversation",
      "networkError": "An error occurred",
      "saveAttachmentNameError": "Error updating attachment name.",
      "unMuteConversationError": "Unable to un-mute conversation",
      "updateConversationError": "Failed to update conversation",
      "updateMessageError": "Error updating message",
      "updateReactionError": "Couldn't update reaction",
      "videoNotSupported": "Your browser does not support the video tag."
    },
    "runAction": "Run action",
    "searchPlaceholder": "Search..."
  },
  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "create": "Create",
    "creating": "Creating",
    "close": "Close",
    "confirm": "Confirm",
    "custom": "Custom",
    "date": "Date",
    "delete": "Delete",
    "deleted": "Deleted",
    "discard": "Discard",
    "loading": "Loading",
    "logout": "Sign out",
    "me": "me",
    "never": "Never",
    "no": "No",
    "ok": "OK",
    "rename": "Rename",
    "save": "Save",
    "saving": "Saving",
    "search": "Search",
    "send": "Send",
    "signOut": "Sign out",
    "sort": {
      "sort": "Sort",
      "byName": "Sort by name",
      "byStatus": "Sort by status",
      "sortnames": "Sort names"
    },
    "time": {
      "hour": "hour",
      "hours": "hours",
      "minute": "minute",
      "minutes": "minutes"
    },
    "timeString": "Time",
    "undoable": "This action can not be undone!",
    "untitled": "Untitled",
    "yes": "Yes"
  },
  "connectivity": {
    "away": "Away",
    "offline": "Offline",
    "online": "Online"
  },
  "invitations": {
    "noMoreInvitations": "You have no invitations yet",
    "success": "You successfully joined.",
    "errorJoiningOperation": "Error joining operation."
  },
  "consent": {
    "alwaysAcceptRequestsFromLabel": "Always accept requests from {0}",
    "cancelButton": "Cancel",
    "confirmButton": "Confirm",
    "consentAutomationGlobalToggleLabel": "Automatically consent to all requests",
    "consentAutomationListTitle": "Always accept requests from:",
    "consentAutomationTitle": "Auto-consents",
    "consentListTitle": "Consent settings",
    "consentOperationListTitle": "Operations",
    "deleteConsentAutomationMessage": "Are you sure you want to delete the auto-consent?",
    "deleteConsentAutomationTitle": "Are you sure you want to delete the auto-consent?",
    "deleteOperation": "Delete operation",
    "deleteOperationButton": "Delete operation",
    "deleteOperationMessage": "You will not be able to recover the operation or any of its contents",
    "expirationDateHeader": "Set expiration date",
    "expired": "Expired",
    "expiresAt": "Expires {0}",
    "leaveOperation": "Leave operation",
    "leaveOperationButton": "Leave operation",
    "leaveOperationMessage": "Are you sure you want to leave the operation?",
    "noConsents": "You have no consent requests yet.",
    "openConsentRequest": "Open consent request",
    "permissions": {
      "decline": "Decline request",
      "joinOperationNoLocation": "Join operation, don’t share location",
      "joinOperationShareLocation": "Join operation and share location",
      "joinOperationShareLocationWithExpiration": "Join operation, share location (set expiration)"
    },
    "requestToJoinOperationMessage": "\"{0}\"  has requested you to join the operation \"{1}\". Please define your sharing permissions. Permissions may be changed or revoked from the Permissions overview in the Settings panel.",
    "requestToJoinOperationTitle": "Request to join \"{0}\"",
    "loadError": "Couldn't find the consent",
    "saveError": "Could not save consent",
    "selectPermissionPlaceholder": "Select permission",
    "setExpirationDate": "Set an expiration date for location sharing",
    "setNewExpirationDate": "Set a new expiration date for location sharing",
    "status": {
      "long": {
        "accepted": "Accepted",
        "rejected": "Consent declined",
        "revoked": "Consent revoked",
        "sent": "Pending"
      },
      "short": {
        "accepted": "",
        "rejected": "Declined",
        "decline": "Decline",
        "revoked": "Revoked",
        "sent": "Pending"
      }
    },
    "stopSharingLocation": "Stop sharing location",
    "startSharingLocation": "Start sharing location",
    "title": "Consent permissions"
  },
  "contains": "Property '{property}' must contain '{seed}'",
  "conversation": {
    "Conversations": "Conversations",
    "Messages": "Messages",
    "Users, groups and operations": "Users, groups and operations",
    "validation": {
      "titleRequired": "Conversation title must not be empty",
      "titleMaxLengthExceeded": "Max characters is {0}",
      "adminRoleRequired": "At least one member with an Admin role is required",
      "invalidRoleSelected": "Selected role no longer exists. Choose valid role."
    },
    "allFiles": "All files",
    "allFilesDeleted": "All files were successfully deleted",
    "composePlaceholder": "Write a message...",
    "configureNotifications": "Mute",
    "createdBy": "Created by",
    "deleteAllConversationFiles": "Do you want to permanently delete all files attached to the conversation",
    "deleteConversationMessage": "Permanently delete the selected conversation? This cannot be undone.",
    "deleteConversationMessageWithTitle": "Permanently delete the selected conversation: \"{0}\"? This cannot be undone.",
    "deleteConversationTitle": "Delete conversation",
    "deleteFiles": "Delete files",
    "details": "Conversation details",
    "empty": "No messages",
    "filesDeleted": "{0} files could not be deleted due to insufficient permissions",
    "keepFiles": "Keep files",
    "markAllAsRead": "Mark all conversations as read",
    "markAsRead": "Mark as read",
    "markAsUnread": "Mark as unread",
    "messageError": "Could not send",
    "messageSending": "Sending",
    "messageSent": "Sent",
    "newActivity": "New activity",
    "newMessages": "new messages",
    "noConversations": "There are no conversations yet.",
    "noChats": "There are no chats yet.",
    "noConversationsForYou": "You have no conversations yet.",
    "noOpenConversations": "There are no open conversations.",
    "selectOneToOpen": "Select a conversation to open it",
    "createNewConversation": "Create a new conversation",
    "addChatButton": "Add chat +",
    "orCreateNewConversation": "or create a new conversation",
    "openInTab": "Open in new panel",
    "origin": "Conversation started {0} by {1}",
    "pin": "Pin conversation",
    "remainingFiles": "Not deleted files",
    "replyingTo": "Replying to {0}",
    "showReadPermittedFiles": "Show all deleted files",
    "showRemaining": "Show not deleted files",
    "successfullyDeleted": "The conversation was successfully deleted",
    "conversationNameLabel": "Conversation name",
    "unMute": "Turn on notifications",
    "unpin": "Un-pin conversation"
  },
  "conversationDialog": {
    "assign-role": "Make {0} of conversation",
    "createTitle": "New conversation",
    "editTitle": "Details for \"{0}\"",
    "filterMembers": "Search",
    "filterMembersPlaceholder": "Type to search...",
    "labelAdmins": "Administrators",
    "labelMembers": "Members",
    "labelName": "Name",
    "removeUser": "Remove from conversation",
    "selectedMembers": "Selected members",
    "titleLabel": "Conversation title",
    "titlePlaceholder": "Add a title..."
  },
  "conversationsList": {
    "admins": "Admins",
    "adminsPlaceholder": "No admins added...",
    "members": "Members",
    "membersPlaceholder": "No members added...",
    "title": "Conversations"
  },
  "darkMode": "Dark mode",
  "device": {
    "registered": "Device registered",
    "updated": "Device registration updated"
  },
  "disconnected": "Not connected! Refresh the page to try again.",
  "drawLayer": {
    "createDrawLayerFailedMessage": "Something went wrong when creating the draw layer",
    "createDrawLayerFailedTitle": "Error creating draw layer",
    "drawLayer": "Draw layer",
    "drawLayers": "Draw layers",
    "drawLayerName": "Draw layer name",
    "drawLayerAddButton": "Add draw layer +",
    "drawLayerInOperationCreate": "New operation draw layer",
    "drawLayerCreatedMessage": "Draw layer \"{0}\" has been created",
    "drawLayerCreatedTitle": "Draw layer created",
    "drawLayerUpdatedMessage": "Draw layer \"{0}\" has been updated",
    "drawLayerUpdatedTitle": "Draw layer updated",
    "drawLayerNameLabel": "Draw layer name",
    "updateDrawLayerFailedMessage": "Something went wrong when updating the draw layer",
    "updateDrawLayerFailedTitle": "Error updating draw layer"
  },
  "drawFeatureSelection": {
    "copyToDrawLayer": "Copy to draw layer",
    "delete": "Delete",
    "deleteFeature": "Delete feature",
    "deleteFeatureConfirmation": "Are you sure you want to delete this feature?",
    "deselect": "Deselect",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "moveToDrawLayer": "Move to draw layer",
    "selectFeature": "Select draw feature",
    "unnamedFeature": "Unnamed feature",
    "updateFailedTitle": "Unable to update draw feature"
  },
  "drawTools": {
    "route": {
      "notEnoughCoordinatesTitle": "No points in map | 1 point in map | {0} points in map",
      "notEnoughCoordinatesDescription": "At least two points or addresses are needed to create a route.",
      "saveRouteButton": "Save route",
      "saveRouteFailedMessage": "Something went wrong when saving the route",
      "closeTitle": "Do you want to discard this route?",
      "closeDescription": "All progress will be lost",
      "searchForAddress": "Search in map",
      "searchLabel": "",
      "searchPlaceholder": "Search for an address",
      "errors": {
        "serviceUnavailable": "Routing service is currently unavailable",
        "serviceUnavailableDetail": "Please try again in a few moments",
        "connectionNotFound": "No route could be found between the points",
        "connectionNotFoundDetail": "Try adjusting your points or use different locations",
        "notEnoughPoints": "Not enough points to create a route",
        "notEnoughPointsDetail": "At least two points are required",
        "pointNotFound": "Could not create route to point {0}",
        "pointNotFoundDetail": "The point may be in an area too far away or without road coverage",
        "pointOutOfBounds": "Point {0} is outside the supported area",
        "pointOutOfBoundsDetail": "Please select a point within the coverage area",
        "pointDistanceExceeded": "Point {0} is too far from the nearest road",
        "pointDistanceExceededDetail": "Try placing the point closer to a road",
        "tooManyPoints": "Too many points",
        "tooManyPointsDetail": "Maximum {0} points allowed",
        "illegalArgument": "Invalid route parameters",
        "illegalArgumentDetail": "Please check your route configuration",
        "runtimeError": "An error occurred while calculating the route",
        "runtimeErrorDetail": "Please try again later",
        "rateLimitExceeded": "Too many route requests",
        "rateLimitExceededDetail": "The route server refused to provide a route due to too many recent route requests.",
        "unknown": "An unknown route error occurred",
        "unknownDetail": "Please double check that all route parameters are correct or try again later."
      }
    },
    "editing": {
      "infoLabel": "Label"
    }
  },
  "geofence": {
    "ruleType": {
      "CROSS_LINE": "Cross line",
      "NO_LOCATION": "No location",
      "IDLE_LOCATION": "Idle location",
      "ENTER": "Enter",
      "EXIT": "Exit",
      "INSIDE_AT": "Inside at",
      "OUTSIDE_AT": "Outside at",
      "CONVERGE": "Converge",
      "DIVERGE": "Diverge",
      "DEVIATE": "Deviate"
    }
  },
  "equals": "Property '{property}' must be equal to '{comparison}'",
  "errors": {
    "addReactionError": "Couldn't add reaction",
    "createConversationError": "Couldn't create conversation",
    "deleteConversationError": "Couldn't delete conversation",
    "deleteMessageError": "Couldn't delete message",
    "deleteReactionError": "Couldn't delete reaction",
    "forwardMessageError": "Couldn't forward message",
    "getAttachmentError": "Error fetching attachments.",
    "loadConversationDetailsError": "Couldn't load conversation details",
    "loadingMessagesError": "Couldn't load messages",
    "muteConversationError": "Unable to mute conversation",
    "networkError": "An error occurred",
    "saveAttachmentNameError": "Error updating attachment name.",
    "unMuteConversationError": "Unable to un-mute conversation",
    "updateConversationError": "Failed to update conversation",
    "updateMessageError": "Error updating message",
    "updateSharingConsent": "Failed to save location settings",
    "updateReactionError": "Couldn't update reaction",
    "videoNotSupported": "Your browser does not support the video tag."
  },
  "event": {
    "markAsReceived_one": "Event marked as received",
    "markAsReceived_other": "Events marked as received",
    "markAsReceived_plural": "Events marked as received",
    "maskAsReceived_plural": "Events marked as received"
  },
  "files": {
    "drop": "Drop files here",
    "dropDisabledWhileEditing": "Attachments are disabled while editing",
    "sort": {
      "label": "Sort by:",
      "modified": "Changed",
      "name": "Filename",
      "size": "Size",
      "uploaded": "Uploaded"
    }
  },
  "forwardingMessage": {
    "errorForwardingMessage": "An error has occurred and the message was not forwarded to the following conversation(s)",
    "forwardedMessage": "Forwarded message",
    "forwardingMessagePopupTitle": "Forwarding to conversations"
  },
  "geoSearch": {
    "noResults": "No results found",
    "defaultLabel": "Search for name, address or coordinates",
    "noName": "No name found",
    "locationNames": {
      "genericStation": "station",
      "subwayStation": "subway station",
      "busStation": "bus station"
    },
    "defaultPlaceholder": ""
  },
  "hoverResource": {
    "callSign": "Call sign",
    "email": "Email",
    "more": "more",
    "name": "Name",
    "noCallSign": "No call sign",
    "unknown": "Unknown",
    "username": "Username"
  },
  "http": {
    "204": {
      "message": "The resource failed to load. Please try to reload it again.",
      "title": "No content"
    },
    "401": {
      "message": "You need to re-authorize.",
      "title": "Unauthorized"
    },
    "403": {
      "message": "You do not have permission to access this resource.",
      "title": "Forbidden"
    },
    "404": {
      "message": "The resource was not found on the service.",
      "title": "Not found"
    },
    "410": {
      "message": "The resource is no longer available.",
      "title": "Gone"
    },
    "500": {
      "message": "The server couldn't process the request. Please contact support if the problem persists.",
      "title": "Internal server error"
    },
    "details": "Show details",
    "noResponse": {
      "message": "Couldn't reach the server.",
      "title": "Network error"
    },
    "wrongstatus": {
      "message": "The server responded in an unexpected way.",
      "title": "Unexpected response"
    }
  },
  "isAlpha": "Property '{property}' must only contain alphabetic characters",
  "isAlphanumeric": "Property '{property}' must only contain alphanumeric characters",
  "isArray": "Property '{property}' must be an array",
  "isAscii": "Property '{property}' must contain only ASCII characters",
  "isBIC": "Property '{property}' must be a valid BIC or SWIFT code",
  "isBase32": "Property '{property}' must be a base32 encoded string",
  "isBase58": "Property '{property}' must be a base58 encoded string",
  "isBase64": "Property '{property}' must be a base64 encoded string",
  "isBoolean": "Property '{property}' must be a boolean",
  "isBooleanString": "Property '{property}' must be a boolean string",
  "isBtcAddress": "Property '{property}' must be a valid Bitcoin address",
  "isByteLength": "Length of '{property}' in bytes must be between {min} and {max}",
  "isCreditCard": "Property '{property}' must be a valid credit card number",
  "isCurrency": "Property '{property}' must be a valid currency amount",
  "isDataURI": "Property '{property}' must be a valid data URI format",
  "isDate": "Property '{property}' must be a valid date",
  "isDateString": "Property '{property}' must be an ISO 8601 date string",
  "isDecimal": "Property '{property}' must be a valid decimal value",
  "isDefined": "Property '{property}' must be defined",
  "isDivisibleBy": "Property '{property}' must be divisible by {number}",
  "isEAN": "Property '{property}' must be a valid EAN",
  "isEmail": "Property '{property}' must be a valid email",
  "isEmpty": "Property '{property}' must be empty",
  "isEnum": "Property '{property}' must be a valid enum value",
  "isEthereumAddress": "Property '{property}' must be a valid Ethereum address",
  "isFQDN": "Property '{property}' must be a fully qualified domain name",
  "isFirebasePushId": "Property '{property}' must be a valid Firebase Push ID",
  "isFullWidth": "Property '{property}' must contain only full-width characters",
  "isHSL": "Property '{property}' must be a valid HSL color",
  "isHalfWidth": "Property '{property}' must contain only half-width characters",
  "isHash": "Property '{property}' must be a valid hash of type {algorithm}",
  "isHexColor": "Property '{property}' must be a valid hexadecimal color",
  "isHexadecimal": "Property '{property}' must be a valid hexadecimal number",
  "isIBAN": "Property '{property}' must be a valid IBAN",
  "isIP": "Property '{property}' must be a valid IP (version 4 or 6)",
  "isISBN": "Property '{property}' must be a valid ISBN (version 10 or 13)",
  "isISIN": "Property '{property}' must be a valid ISIN",
  "isISO31661Alpha2": "Property '{property}' must be a valid ISO 3166-1 alpha-2 country code",
  "isISO31661Alpha3": "Property '{property}' must be a valid ISO 3166-1 alpha-3 country code",
  "isISO4217CurrencyCode": "Property '{property}' must be a valid ISO 4217 currency code",
  "isISO8601": "Property '{property}' must be a valid ISO 8601 date",
  "isISRC": "Property '{property}' must be a valid ISRC",
  "isISSN": "Property '{property}' must be a valid ISSN",
  "isIdentityCard": "Property '{property}' must be a valid identity card number",
  "isIn": "Property '{property}' must be one of the following values: {values}",
  "isInstance": "Property '{property}' must be an instance of {value}",
  "isInt": "Property '{property}' must be an integer",
  "isJSON": "Property '{property}' must be a valid JSON",
  "isJWT": "Property '{property}' must be a valid JWT",
  "isLatLong": "Property '{property}' must be a valid latitude-longitude coordinate",
  "isLatitude": "Property '{property}' must be a valid latitude coordinate",
  "isLocale": "Property '{property}' must be a valid locale",
  "isLongitude": "Property '{property}' must be a valid longitude coordinate",
  "isLowercase": "Property '{property}' must be in lowercase",
  "isMACAddress": "Property '{property}' must be a valid MAC address",
  "isMagnetURI": "Property '{property}' must be a valid magnet URI",
  "isMilitaryTime": "Property '{property}' must be a valid military time in the format HH:MM",
  "isMimeType": "Property '{property}' must be a valid MIME type",
  "isMobilePhone": "Property '{property}' must be a valid mobile phone number",
  "isMongoId": "Property '{property}' must be a valid MongoDB ObjectId",
  "isMultibyte": "Property '{property}' must contain one or more multibyte characters",
  "isNegative": "Property '{property}' must be a negative number",
  "isNotEmpty": "Property '{property}' cannot be empty",
  "isNotEmptyObject": "Property '{property}' must not be an empty object",
  "isNotIn": "Property '{property}' must not be one of the following values: {values}",
  "isNumber": "Property '{property}' must be a number",
  "isNumberString": "Property '{property}' must be a numeric string",
  "isObject": "Property '{property}' must be a valid object",
  "isOctal": "Property '{property}' must be a valid octal number",
  "isPassportNumber": "Property '{property}' must be a valid passport number for the specified country",
  "isPhoneNumber": "Property '{property}' must be a valid phone number",
  "isPort": "Property '{property}' must be a valid port number",
  "isPositive": "Property '{property}' must be a positive number",
  "isPostalCode": "Property '{property}' must be a valid postal code",
  "isRFC3339": "Property '{property}' must be a valid RFC 3339 date",
  "isRgbColor": "Property '{property}' must be a valid RGB or RGBA color",
  "isSemVer": "Property '{property}' must be a valid Semantic Versioning Specification (SemVer)",
  "isString": "Property '{property}' must be a string",
  "isStrongPassword": "Property '{property}' must be a strong password",
  "isSurrogatePair": "Property '{property}' must contain one or more surrogate pair characters",
  "isTaxId": "Property '{property}' must be a valid tax ID",
  "isTimeZone": "Property '{property}' must be a valid IANA time-zone",
  "isUUID": "Property '{property}' must be a valid UUID",
  "isUppercase": "Property '{property}' must be in uppercase",
  "isUrl": "Property '{property}' must be a valid URL",
  "isVariableWidth": "Property '{property}' must contain a mixture of full and half-width characters",
  "length": "Property '{property}' must be between {min} and {max} characters",
  "lightMode": "Light mode",
  "systemDefault": "System default",
  "matches": "Property '{property}' must match the pattern {pattern}",
  "max": "Property '{property}' must not be greater than {maxValue}",
  "maxDate": "Property '{property}' must be a date before {date}",
  "maxLength": "Property '{property}' must be no longer than {max} characters",
  "memberPicker": {
    "removeUser": "Remove user"
  },
  "message": {
    "couldntForward": "Couldn't forward message",
    "couldntForwardTo": "Message was not forwarded to {0}",
    "delete-message-message": "{0}",
    "delete-message-modal-title": "Delete message?",
    "delete-message-modal-description": "This message will be permanently deleted, and any attachments will also be deleted. This action cannot be undone.",
    "delete-message-prompt": "This message will be permanently deleted",
    "delete-message-prompt-with-message": "Are you sure you want to delete the message: \"{0}\"?",
    "delete-message-prompt-with-message-and-attachment": "Are you sure you want to delete the message: \"{0}\"? This will also delete the attachments.",
    "delete-message-title": "Are you sure you want to delete the message?",
    "deleted": "This message has been deleted",
    "editedMessage": "Edited message",
    "editingMessage": "Editing message",
    "forwardedBy": "Fwd. by {0}",
    "forwardedMessage": "Forwarded Message",
    "messageNotSeenYet": "This message has not been seen yet",
    "showEntireMessage": "Show entire message...",
    "showLess": "Show less",
    "reactions": "Reactions",
    "repliedTo": "Replied to",
    "seenTimeDescription": "Last seen",
    "seenTitle": "Seen by"
  },
  "messageActions": {
    "delete": "Delete message",
    "edit": "Edit message",
    "forward": "Forward",
    "react": "React to message",
    "reply": "Reply",
    "seenBy": "Seen by"
  },
  "seenByModal": {
    "titleSingle": "Seen by 1 person",
    "title": "Seen by {0} people"
  },
  "min": "Property '{property}' must not be less than {minValue}",
  "minDate": "Property '{property}' must be a date after {date}",
  "minLength": "Property '{property}' must be at least {min} characters long",
  "noResults": "No matches for \"{0}\"",
  "notContains": "Property '{property}' must not contain '{seed}'",
  "notEmpty": "Property '{property}' can not be empty",
  "notEquals": "Property '{property}' must not be equal to '{comparison}'",
  "notifications": {
    "active": "Active",
    "adjustTime": "Adjust time",
    "chatMutedUntil": "Mute until",
    "customNotificationsHeader": "Pause notifications until...",
    "deleteAllNotifications": "Delete all notifications",
    "deleteAllNotificationsConfirmation": "Are you sure you want to delete all notifications? This cannot be undone.",
    "disableNotificationsFor": "Disable notifications for",
    "explain1h": "You will not receive notifications for this conversation the next hour",
    "explain30m": "You will not receive notifications for this conversation the next 30 minutes",
    "explain8h": "You will not receive notifications for this conversation the next 8 hours",
    "explainIndefinite": "You will not receive notifications for this conversation until you change this setting",
    "explainUnmute": "You will receive all notifications for this conversation",
    "explainUntil": "You will not receive notifications for this conversation until {0}",
    "isDisabled": "Notifications are disabled",
    "mute1h": "Mute for one hour",
    "mute30m": "Mute for 30 minutes",
    "mute8h": "Mute for 8 hours",
    "muteIndefinite": "Until enabled",
    "muteUntil": "Mute until",
    "mutedUntil": "Until {0}",
    "noNotifications": "You have no notifications",
    "resume": "Resume notifications",
    "unmute": "Receive notifications for this conversation"
  },
  "offlineBanner": {
    "noInternet": "No internet connectivity",
    "reconnected": "Reconnected",
    "tryingToReconnect": "No internet connectivity"
  },
  "operation": {
    "createOperationFailedMessage": "Something went wrong when creating the operation",
    "createOperationFailedTitle": "Error creating operation",
    "newOperation": "New operation",
    "editOperation": "Edit operation",
    "leaveOperation": "Leave operation",
    "leaveOperationButton": "Leave operation",
    "leaveOperationMessage": "Are you sure you want to leave the operation?",
    "noOperations": "You have no operations yet.",
    "operationCreatedMessage": "Operation \"{0}\" has been created",
    "operationCreatedTitle": "Operation created",
    "operationUpdatedMessage": "Operation \"{0}\" has been updated",
    "operationUpdatedTitle": "Operation updated",
    "removeUser": "Remove from operation",
    "noOtherMembers": "No other member(s)",
    "addMemberButton": "Add member +",
    "operationNameLabel": "Operation name",
    "roleLabel": "Role",
    "validation": {
      "operationNameRequired": "Operation name must not be empty",
      "operationNameMaxLengthExceeded": "Max characters is {0}",
      "conversationNameRequired": "Chat name must not be empty",
      "conversationNameMaxLengthExceeded": "Max characters is {0}",
      "drawLayerNameRequired": "Draw layer name is required",
      "drawLayerNameMaxLengthExceeded": "Max characters is {0}",
      "defaultDrawLayerRequired": "Default draw layer required",
      "adminRoleRequired": "At least one member with an Admin role is required",
      "invalidRoleSelected": "Selected role no longer exists. Choose a valid role."
    }
  },
  "or": "or",
  "reconnecting": "Not connected! Trying to reconnect",
  "searchResults": {
    "allConversationResults": "All results for conversations",
    "allGroupResults": "All results for groups",
    "allMessageResults": "All results for messages",
    "allResourceResults": "All results for users and groups",
    "allUserResults": "All results for users",
    "conversations": "Conversations",
    "groups": "Groups",
    "noGroupsTitle": "You have no groups yet",
    "loadMore": "Load more",
    "messages": "Messages",
    "noResults": "No results found",
    "showAllConversationResults": "Show all conversation results",
    "showAllMessageResults": "Show all message results",
    "showAllResourceResults": "Show all user and group results",
    "title": "Search results for \"{0}\":",
    "users": "Users"
  },
  "settings": {
    "permissions": "Consent permissions",
    "map": "Map settings",
    "title": "Settings"
  },
  "title": {
    "chat": "Chats",
    "files": "Files"
  },
  "trackers": {
    "deleteTrackerTitle": "Delete tracker",
    "deleteTrackerMessage": "Are you sure you want to delete this tracker?"
  },
  "urlDialog": {
    "cancel": "Cancel",
    "continue": "Continue",
    "description": "You are about to navigate to an external website. Are you sure you want to continue?",
    "header": "Warning"
  },
  "workspaceDialog": {
    "dialogHeader": "Connect to a new workspace",
    "serverUrl": "Server URL",
    "serverUrlPlaceholder": "Enter server URL",
    "workspaceSwitcher": "Workspace switcher",
    "invalidUrlError": "Please enter a valid https URL.",
    "cantReachWorkspace": "Unable to reach provided workspace"
  }
}
